<template>
    <div>
        <e-dialog
                dialogType="other"
                dialog-title="查看详情"
                :center-dialog-visible="viewDetailVisible"
                popup-width="840px"
                :isShowConfirm="false"
                :closisShowConfirmeBtn="true"
                @resetPopupData="handleClose">
            <div>
                <tableList
                        maxHeight="340"
                        rowKey="id"
                        :loading="loading"
                        :indexShow="indexShow"
                        :table-data="tableData"
                        :table-label="tableLabel">
                    <template v-slot:prodName="{scope:{row}}">
                        <span>{{ row.prodName ? row.prodName : row.productName}}</span>
                    </template>
                </tableList>
                <e-pager
                        style="margin-top: 20px"
                        :isSimple="isSimple"
                        :page-index="queryData.pageNum"
                        :total="queryData.total"
                        :page-size="queryData.pageSize"
                        @change="handleCurrentChange"
                ></e-pager>
            </div>
        </e-dialog>
    </div>
</template>

<script>
import eDialog from '../../../components/common/e-dialog.vue';
import tableList from '../../../components/common/e-table-list';
import ePager from '../../../components/common/e-pager.vue';
import api from '../../../api/order';

export default {
  components: {
    eDialog,
    tableList,
    ePager
  },
  props: {
    viewDetailVisible: Boolean,
    id: Number,
    type: Number,
    purchaseCompanyId: Number
  },
  data() {
    return {
      loading: true,
      indexShow: true,
      isSimple: true,
      tableData: [],
      tableLabel: [
        {
          label: '计量单位', param: 'unit', align: 'center', width: '110',
          render: (row) => {
            return row.baseUnitName ? row.baseUnitName : row.unit;
          },
        },
        {
          label: '数量', param: 'numCount', align: 'center',
          render: (row) => {
            return row.quantity ? row.quantity : row.numCount;
          },
        },
        {label: '协议编号', param: 'sinoProtocol', align: 'center', width: '180'},
        {
          label: '物资描述', param: 'productName', align: 'center', width: '360', tooltip: true, slot: 'prodName'
        },
      ],
      queryData: {
        purchasePlanId: null,
        purchaseCompanyId: null,
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.handleQueryPage();
    },
    handleClose() {
      this.$emit('update:viewDetailVisible', false);
    },
    async queryPage(methodName) {
      const res = await api[methodName]({...this.queryData, orderId: this.$route.query.orderId});
      if (res.code === '200') {
        this.tableData = res.data.records || [];
        this.queryData.total = res.data.total;
        this.loading = false;
      }
    },
    handleQueryPage() {
      if (this.type === 1) {//剔除协议编号
        // this.tableLabel.splice(2, 1);
        this.tableLabel = this.tableLabel.filter((item) => item.label !== '协议编号');
        this.queryData.purchasePlanId = this.id;
        this.queryPage('ecPurchasePlanSkuQueryPage');
      } else {
        this.queryData.petroMallOrderId = this.id;
        this.queryPage('petroMallOrderSkuQueryPage');
      }
    },
  },
  mounted() {
    this.queryData.purchaseCompanyId = this.purchaseCompanyId;

    setTimeout(() => {
      this.handleQueryPage();
    }, 500);

  }
};
</script>

<style scoped lang="scss">

</style>
